import { render, staticRenderFns } from "./Growth2.vue?vue&type=template&id=56ffd94e&scoped=true&"
import script from "./Growth2.vue?vue&type=script&lang=js&"
export * from "./Growth2.vue?vue&type=script&lang=js&"
import style0 from "./Growth2.vue?vue&type=style&index=0&id=56ffd94e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ffd94e",
  null
  
)

export default component.exports